import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";
import { InterfaceStore, RouteInterface} from "./interface/InterfaceStore";

export const getTypeWalk = () => {
    return httpConsulta.get(`/getAllTipoVeiculo`);
}

export const postParticularityStore = (data: RouteInterface) => {
    return httpConsulta.post(`/insertParticularidadeLoja`, data);
}

export const getParticularityStore = (data: string) => {
    return httpConsulta.get(`/getParticularidadeLojaById?cd=${data}`);
}

export const updateParticulatiryStore = (data: RouteInterface) => {
    return httpConsulta.post(`/updateParticularidadeLoja`, data)
}